import {
  TuberculosisHistoryDtoImmunosuppressionStatus,
  TuberculosisHistoryDtoPreviousBloodTestResult,
} from '../api/generated/model';

export function getTuberculosisHistoryStatusName(status: TuberculosisHistoryDtoImmunosuppressionStatus) {
  switch (status) {
    case TuberculosisHistoryDtoImmunosuppressionStatus.YES:
      return 'Ja';
    case TuberculosisHistoryDtoImmunosuppressionStatus.NO:
      return 'Nein';
    case TuberculosisHistoryDtoImmunosuppressionStatus.UNKNOWN:
      return 'Unbekannt';
  }
}

export function getTuberculosisHistoryBloodTestResultName(result: TuberculosisHistoryDtoPreviousBloodTestResult) {
  switch (result) {
    case TuberculosisHistoryDtoPreviousBloodTestResult.POSITIVE:
      return 'Positiv';
    case TuberculosisHistoryDtoPreviousBloodTestResult.NEGATIVE:
      return 'Negativ';
    case TuberculosisHistoryDtoPreviousBloodTestResult.INDETERMINATE:
      return 'Unbestimmt';
    case TuberculosisHistoryDtoPreviousBloodTestResult.UNKNOWN:
      return 'Unbekannt';
  }
}
